<template>
  <div
    class="menu-with-submenu min-width-calc"
    :class="!subMenuAvailable ? 'opacity-50 cursor-not-allowed' : ''"
    ref="menuItem"
  >
    <div class="flex items-center gap-1 ltr:mr-2 rtl:ml-2">
      <span
        v-if="variant === 'icon' && option.icon"
        class="material-symbols-outlined text-[16px]/[16px] select-none"
        :class="option.iconColor ? option.iconColor : 'text-gray-500'"
      >
        {{ option.icon }}
      </span>
      <span
        v-if="variant === 'image' && option.icon"
        class="flex items-center justify-center w-4 h-4"
      >
        <span
          class="icon-mask"
          :class="`icon-${option.key}`"
          :style="{
            '-webkit-mask-image': `url(${option.icon})`,
            'mask-image': `url(${option.icon})`,
          }"
          :aria-label="option.label"
        />
      </span>
      <p class="m-0 text-sm text-gray-500">{{ option.label }}</p>
    </div>
    <fluent-icon :icon="chevronDirection" size="12" />
    <div
      v-if="subMenuAvailable"
      ref="submenu"
      class="submenu"
      :class="{'top-0': !isOffscreen, 'bottom-0': isOffscreen, 'hidden': !isVisible}"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    option: {
      type: Object,
      default: () => {},
    },
    subMenuAvailable: {
      type: Boolean,
      default: true,
    },
    variant: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isOffscreen: false,
      isVisible: true,
    };
  },
  computed: {
    isRTL() {
      return this.$root.$i18n.locale === 'he';
    },
    chevronDirection() {
      return this.isRTL ? 'chevron-left' : 'chevron-right';
    },
  },
  mounted() {
    this.checkPosition();
  },
  methods: {
    checkPosition() {
      this.$nextTick(() => {
        const menuItem = this.$refs.menuItem;
        const submenu = this.$refs.submenu;
        if (!menuItem || !submenu) return;

        const menuItemRect = menuItem.getBoundingClientRect();
        const submenuRect = submenu.getBoundingClientRect();
        this.isVisible = false;
        const combinedBottom = menuItemRect.top + menuItemRect.height + submenuRect.height;
        const isOffscreen = combinedBottom > window.innerHeight;

        if (isOffscreen !== this.isOffscreen) {
          this.isOffscreen = isOffscreen;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.menu-with-submenu {
  min-width: calc(6.25rem * 2);
  @apply w-full px-2 py-1 flex items-center h-7 rounded-md relative bg-white dark:bg-slate-700 justify-between;
  @apply hover:bg-green-50 hover:text-[#164B35] cursor-pointer dark:hover:bg-slate-800;

  &:hover {
    .material-symbols-outlined {
      @apply text-[#1F845A];
    }
    .submenu {
      @apply block;
    }

    .icon-mask {
      background-color: #1f845a;
    }
  }
}

.icon-mask {
  background-color: #6b7280;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-position: center;
  mask-position: center;
}

.icon-snoozed {
  width: 11px;
  height: 14px;
}

.submenu {
  @apply bg-white dark:bg-slate-700 shadow-lg rounded-lg absolute;
  @apply ltr:left-full rtl:right-full max-h-[15rem] overflow-y-auto overflow-x-hidden;
  @apply min-w-[150px] cursor-pointer;
}
</style>
